'use client';

import { PositionDirection } from '@velocity-exchange/sdk';
import { matchEnum, UIMarket } from '@velocity-exchange/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';

interface OrderActionLabelProps {
	order: ParentOrderInfo;
}

export function OrderActionLabel({ order }: OrderActionLabelProps) {
	const { direction, reduceOnly, marketIndex, marketType } = order;
	const uiMarket = new UIMarket(marketIndex, marketType);
	const isLong = matchEnum(direction, PositionDirection.LONG);

	const label = uiMarket.isPerp
		? reduceOnly
			? `Close ${isLong ? 'Short' : 'Long'}`
			: isLong
				? 'Long'
				: 'Short'
		: isLong
			? 'Buy'
			: 'Sell';

	return (
		<span
			className={
				isLong
					? 'text-text-positive-green-button'
					: 'text-text-negative-red-button'
			}
		>
			{label}
		</span>
	);
}
